/** Regex for a valid integer number. */
export const INTEGER_REGEX = new RegExp(/^(-)?[0-9]*$/)

/** Regex for a valid decimal/float. Accepts both dot(.) and comma(,) as seperators. */
export const DECIMAL_REGEX = new RegExp(/^(-)?[0-9]*(\.|,)?[0-9]*$/)
